module.exports = __webpack_public_path__ + "media/images/company-logo-a99536992e8e7c35af25af464035b96b.svg";